import { render, staticRenderFns } from "./AnteprimaAstaDxTop.vue?vue&type=template&id=dd29e50a&"
import script from "./AnteprimaAstaDxTop.vue?vue&type=script&lang=js&"
export * from "./AnteprimaAstaDxTop.vue?vue&type=script&lang=js&"
import style0 from "./AnteprimaAstaDxTop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports